import { render } from "./VSvg.vue?vue&type=template&id=79ba095c"
import script from "./VSvg.vue?vue&type=script&lang=js"
export * from "./VSvg.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__